import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported, type Messaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
let messagingInstance: Messaging | null = null;

const getMessagingInstance = async () => {
  if (messagingInstance) {
    return messagingInstance;
  }

  try {
    const supported = await isSupported();
    if (!supported) {
      return null;
    }

    messagingInstance = getMessaging(app);
    return messagingInstance;
  } catch (error) {
    console.log('Firebase messaging is not supported in this browser.', error);
    return null;
  }
};

export const getFCMToken = async () => {
  try {
    const messaging = await getMessagingInstance();
    if (!messaging) {
      return null;
    }

    const currentToken = await getToken(messaging, {
      vapidKey: import.meta.env.VITE_FIREBASE_WEB_PUSH_KEY,
    });
    if (currentToken) {
      return currentToken;
    } else {
      console.log('No registration token available. Request permission to generate one.');
      return null;
    }
  } catch (error) {
    console.log('An error occurred while retrieving token. ', error);
    return null;
  }
};

export const getFirebaseMessaging = async () => getMessagingInstance();
